<h3-objectless-view-settings-slider
  label="Contrast"
  [default]="defaultContrast"
  [setting]="settingName"
  [nasModel]="layerStore"
  [disabled]="disabled$ | async"
  [settingStore]="layerStore"
></h3-objectless-view-settings-slider>
